import jsPDF from 'jspdf'

export class CouponPDF {
    constructor(lines) {
        const width = 233
        const size = 25 + 9.5 * lines.length
        const orientation = size < width ? 'l' : 'p'
        const doc = new jsPDF({
            format: [width, size],
            orientation, 
            unit: 'pt',
        })
        
        this.doc = doc
        this.addCoupon(lines)
    }

    text = (text, x, y, align) =>
        this.doc.text(text, x, y, undefined, undefined, align)

    addCoupon(lines) {
        this.doc.setFont('courier')
        this.doc.setFontSize(8)
        this.doc.setFontType('bold')
        this.doc.text(lines, 20, 22)
    }

    download = (filename) => this.doc.save(`${filename}.pdf`)
    
    open = (autoPrint = false) => {
        if (autoPrint) {
            this.doc.autoPrint()
        }

        window.open(this.doc.output('bloburl'))
    }
}